import type { ReactNode } from 'react';

export const symbol_text_rotation_none: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M726-196H190q-13 0-21.5-8.5T160-226q0-13 8.5-21.5T190-256h536l-31-31q-9-9-9-21t9-21q9-9 21-9t21 9l82 82q9 9 9 21t-9 21l-82 82q-9 9-21 9t-21-9q-9-9-9-21t9-21l31-31ZM384-522l-37 105q-3 8-9.5 12.5T323-400q-14 0-21.5-11t-2.5-24l144-387q3-8 10-13t16-5h21q9 0 16 5t10 13l144 388q5 13-2.5 23.5T636-400q-8 0-14.5-4.5T612-417l-37-105H384Zm16-44h160l-78-222h-4l-78 222Z"
		/>
	</svg>
);
